import { useAnalyticsDispatchContext } from "../../../context/AnalyticsContext";
import BuildMetricsChoice from "../../../utils/BuildMetricsChoice";

function AnalyticsGraphHook(metrics, metrics_id) {
    const metricsChoice = BuildMetricsChoice(metrics);

    const dispatch = useAnalyticsDispatchContext();

    const getMetricValue = () => {
        const metric = getMetric();
        if (!metric) return null;
        return metric.value ? metric.text : metric.id;
    };

    const getMetric = () => {
        const indexMetric = metricsChoice.findIndex((metric) => metric.index == metrics_id);
        if (indexMetric === -1) return null;
        return metricsChoice[indexMetric];
    };

    const setChoiceMetric = (index) => {
        var indexMetric = metricsChoice.findIndex((metric) => metric.index == metrics_id);

        if (indexMetric == -1) {
            console.error();
        }
        indexMetric = indexMetric + index;

        indexMetric = indexMetric == -1 ? metricsChoice.length - 1 : indexMetric;
        indexMetric = indexMetric == metricsChoice.length ? 0 : indexMetric;

        const value = metricsChoice[indexMetric].value;

        var payload = { condition_id: null, redirection_id: null, categorization_id: null, metrics_id: null };

        var [id, type] = [0, ""];
        if (value != null) {
            [id, type] = value.split("-");
            payload = { ...payload, [type]: id, metrics_id: id };
        }

        const typesMetrics = {
            condition_id: "conditions",
            redirection_id: "redirections",
            categorization_id: "categorizations",
        };

        if (type) {
            var IndexMetricPrecise = metrics[typesMetrics[type]].findIndex((metric) => metric.id == id);
            var data = metrics[typesMetrics[type]][IndexMetricPrecise];
            var max = 0;

            for (let key in data.values) {
                for (let date in data.values[key]) {
                    if (data.values[key][date] > max) {
                        max = data.values[key][date];
                    }
                    data.values[key][date] = 0;
                }
            }

            metrics[typesMetrics[type]][IndexMetricPrecise].max = max;

            payload = { ...payload, ...metrics };
        }

        dispatch({ type: "setResultInformation", payload });
    };

    return { setChoiceMetric, getMetric, getMetricValue };
}

export default AnalyticsGraphHook;
